function getCANsenseColour(status, severity = null, theme = null) {
  /**
   * @function getCANsenseColour
   * @param {string} status - The status from your backend (firing, acknowledged, ok, inactive)
   * @param {string} severity - Highest severity level (critical, error, warning, info)
   * @param {Object} theme - Optional MUI theme object for consistent theming
   * @returns {string} - The color associated with the status and severity
   */
  
  console.log('[getCANsenseColour] status:', status, 'severity:', severity);
  
  // If theme is provided, use MUI theme colors for consistency
  if (theme) {
    switch (status?.toLowerCase()) {
      case 'firing':
      case 'active':
      case 'new':
        // CRITICAL/NEW alerts - Use full intensity colors based on severity
        switch (severity?.toLowerCase()) {
          case 'critical':
            return theme.palette.error.dark; // Dark red - most urgent
          case 'error':
            return theme.palette.error.main; // Standard red
          case 'warning':
            return theme.palette.warning.main; // Orange/amber
          case 'info':
            return theme.palette.info.main; // Blue
          default:
            return theme.palette.error.main; // Default to red for unknown severity
        }
      
      case 'pending':
        return theme.palette.warning.light; // Light amber - transitional state
      
      case 'acknowledged':
        // ACKNOWLEDGED alerts - Use lighter/muted colors to show they're being worked on
        switch (severity?.toLowerCase()) {
          case 'critical':
            return theme.palette.warning.main; // Amber instead of red - being handled
          case 'error':
            return theme.palette.warning.main; // Amber instead of red - being handled  
          case 'warning':
            return theme.palette.warning.light; // Light amber
          case 'info':
            return theme.palette.info.light; // Light blue
          default:
            return theme.palette.warning.main; // Default amber for acknowledged
        }
      
      case 'resolved':
      case 'ok':
        return theme.palette.success.main; // Green - all good
      
      case 'inactive':
      case 'disconnected':
        return theme.palette.grey[500]; // Grey - inactive/unknown
      
      default:
        // Fallback for unknown status
        console.warn('[getCANsenseColour] Unknown status:', status);
        return theme.palette.grey[500];
    }
  }
}

export { getCANsenseColour };
export default getCANsenseColour;